import React from "react";
import { Chip } from "@mui/material";

const STYLES = {
  draft: { bg: "rgba(158,158,158,0.2)", color: "#bdbdbd" },
  in_review: { bg: "rgba(255,152,0,0.2)", color: "#ffb74d" },
  approved: { bg: "rgba(42,245,152,0.2)", color: "#2af598" },
  expired: { bg: "rgba(244,67,54,0.2)", color: "#ef5350" },
  missing_docs: { bg: "rgba(255,87,34,0.2)", color: "#ff7043" },
  rejected: { bg: "rgba(183,28,28,0.25)", color: "#e57373" },
};

export default function KycStatusChip({ status }) {
  const key = status || "draft";
  const s = STYLES[key] || STYLES.draft;
  const label = String(key).replace(/_/g, " ");
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        height: 22,
        fontSize: 11,
        fontWeight: 700,
        textTransform: "capitalize",
        bgcolor: s.bg,
        color: s.color,
        border: `1px solid ${s.color}44`,
      }}
    />
  );
}
